import { Component, Inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { ConfirmDialogVariant } from '../../dialogs.types';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { DialogComponentI, DialogData } from '../dialog/dialog.component';

type Record = { name: string };

type DialogInputData = {
  records: Record[];
};

@Component({
  selector: 'rt-protected-controls-dialog',
  templateUrl: './protected-controls-dialog.component.html',
  imports: [ConfirmDialogComponent, TranslatePipe],
})
export class ProtectedControlsDialogComponent implements DialogComponentI<{}, boolean> {
  public readonly ConfirmDialogVariant = ConfirmDialogVariant;

  constructor(@Inject(DialogData) public data: DialogInputData) {}

  public trackBy(index: number, report: Record): any {
    return report.name;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(): void {}
}
